var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTPending({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1070",
    cx: 7.2605,
    cy: 7.5,
    r: 5.51348,
    fill: "white",
    stroke: "#7B7B7B",
    strokeWidth: 2.97303
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTPending);
export default __webpack_public_path__ + "static/media/tPending.0df15772b717aa3ae45be3951e9019c1.svg";
export { ForwardRef as ReactComponent };